import {
  WIDTH_DOUBLE_AIGUILLAGE,
  WIDTH_SIMPLE_AIGUILLAGE,
  WIDTH_TEXT_VOIE,
} from '../constants/constants'
import {ESwitchType, TSwitch} from '../types/project.type'
import {stretchExtra, type TAxisStretch} from './axisStretch'

const calculateWidthSecteur = (
  start: number,
  end: number,
  switches: TSwitch[],
  kmEnd_project: number,
  echantillon: number,
  stretches: TAxisStretch[] = [],
) => {
  const aiType3ForThisSecteur = switches.filter(
    ele_ai =>
      ele_ai.isActive &&
      ele_ai.kmPoint >= start &&
      ele_ai.kmPoint < end &&
      ele_ai.type === ESwitchType.DOUBLE,
  )
  const aiType12ForThisSecteur = switches.filter(
    ele_ai =>
      ele_ai.isActive &&
      ele_ai.kmPoint >= start &&
      ele_ai.kmPoint < end &&
      ele_ai.type !== ESwitchType.DOUBLE,
  )
  const totalAi = aiType3ForThisSecteur.length + aiType12ForThisSecteur.length
  const endKM = end === kmEnd_project ? end + echantillon : end
  const widthSecteur =
    ((endKM - start) / echantillon - totalAi) * WIDTH_TEXT_VOIE +
    aiType12ForThisSecteur.length * WIDTH_SIMPLE_AIGUILLAGE +
    aiType3ForThisSecteur.length * WIDTH_DOUBLE_AIGUILLAGE
  return widthSecteur + stretchExtra(stretches, start, end, echantillon)
}

export {calculateWidthSecteur}
